import axios from 'axios';
import { getApiUrl } from '../utils/site';

export const getDashboardSummary = async (token) => {
  const res = await axios.get(getApiUrl('/api/dashboard/summary'), {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};

export const getOrderMetrics = async (token) => {
  const res = await axios.get(getApiUrl('/api/orders/metrics/summary'), {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};

export const getUserStats = async (token) => {
  const res = await axios.get(getApiUrl('/api/users/stats/summary'), {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};

export const getTodaysSales = async (token) => {
  const res = await axios.get(getApiUrl('/api/orders/todays-sales'), {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};

export const getDeliveryStats = async (token) => {
  const res = await axios.get(getApiUrl('/api/orders/delivery-stats'), {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};

export const getVisitorStats = async (token) => {
  const res = await axios.get(getApiUrl('/api/users/visitor-stats'), {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};
